module.exports = __webpack_public_path__ + "img/Logo_OJK_2.f5a1f6fd.png";